import React, { useState } from 'react';
import Card from '../Card/Card';
import SnackBar from '../../SnackBar';

interface ChartAxesCardsProps {
  chartType: string;
  selectedDynamicMeasureProps?: any;
  currentChartAxes: any;
  bIndex: number;
  uID?: string;
  name: string;
  dynamicMeasureState: any;
  propKey: string;
  tabTileProps: any;
  chartProp: any;
}

const ChartAxesCards: React.FC<ChartAxesCardsProps> = ({
  chartType,
  selectedDynamicMeasureProps,
  currentChartAxes,
  bIndex,
  uID,
  name,
  dynamicMeasureState,
  propKey,
  tabTileProps,
  chartProp,
}) => {
  const [showPopup, setShowPopup] = useState<{ message: string; show: boolean } | null>(null);
  //axis title is name which is Extra_Measure in extra measure case
  return (
    <>
      {chartType === 'richText'
        ? selectedDynamicMeasureProps?.chartAxes[bIndex]?.fields?.map(
            (field: any, index: number) => (
              <Card
                field={field}
                uID={uID || ''}
                bIndex={bIndex}
                axisTitle={name}
                key={index}
                itemIndex={index}
                propKey={`${dynamicMeasureState.selectedDynamicMeasureId}.${dynamicMeasureState.selectedTileId}`}
                tabTileProps={tabTileProps}
                chartProp={chartProp}
                dynamicMeasureState={dynamicMeasureState}
                snackBarOptions={setShowPopup}
              />
            ),
          )
        : currentChartAxes[bIndex]?.fields?.map((field: any, index: number) => (
            <Card
              field={field}
              uID={uID || ''}
              bIndex={bIndex}
              axisTitle={name}
              key={index}
              itemIndex={index}
              propKey={propKey}
              tabTileProps={tabTileProps}
              chartProp={chartProp}
              dynamicMeasureState={dynamicMeasureState}
              snackBarOptions={setShowPopup}
            />
          ))}
      {showPopup && (
        <SnackBar
          show={showPopup.show}
          message={showPopup.message}
          onClose={() => setShowPopup(null)}
        />
      )}
    </>
  );
};

export default ChartAxesCards;
